export function setCookie(name, value, options) {
  const opts = options || {};

  let expires = opts.expires;

  if (typeof expires === 'number' && expires) {
    const date = new Date();
    date.setTime(date.getTime() + expires * 1000);
    expires = opts.expires = date;
  }
  if (expires && expires.toUTCString) {
    opts.expires = expires.toUTCString();
  }

  const val = encodeURIComponent(value);

  let updatedCookie = name + '=' + val;

  for (const propName in opts) {
    if (opts.hasOwnProperty(propName)) {
      updatedCookie += '; ' + propName;
      const propValue = opts[propName];
      if (propValue !== true) {
        updatedCookie += '=' + propValue;
      }
    }
  }

  document.cookie = updatedCookie;
}

/**
 * Delete a cookie. Pass options.domain to remove a cookie that was set with a specific domain.
 * @param {string} name - Cookie name
 * @param {{ domain?: string, path?: string }} options - Optional domain/path (required to clear cookies set with domain)
 */
export function deleteCookie(name, options = {}) {
  const base = { expires: -1, path: options.path || '/' };
  if (options.domain) {
    setCookie(name, '', { ...base, domain: options.domain });
  } else {
    setCookie(name, '', base);
  }
}

export function getCookie(name) {
  var matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function deleteAllCookies({ patterns = [], regex = null } = {}) {
  const cookies = document.cookie.split(";");
  
  cookies.forEach(cookie => {
    const name = cookie.split("=")[0].trim();
    const lowerName = name.toLowerCase();
    
    let shouldDelete = false;
    
    if (regex instanceof RegExp) {
      shouldDelete = regex.test(name);
    } else if (Array.isArray(patterns) && patterns.length > 0) {
      shouldDelete = patterns.some(p => lowerName.includes(p.toLowerCase()));
    } else {
      		// If neither patterns nor regex is specified — remove everything
      shouldDelete = true;
    }
    
    if (shouldDelete) {
      const domainParts = window.location.hostname.split(".");
      const pathParts = window.location.pathname.split("/");
      
      		// Try to remove by all possible combinations of domain and path
      for (let i = 0; i < domainParts.length; i++) {
        const domain = domainParts.slice(i).join(".");
        for (let j = pathParts.length; j >= 0; j--) {
          const path = "/" + pathParts.slice(0, j).join("/");
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain};`;
        }
      }
      
      		// Also try to remove without specifying domain and path
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
}

